module.exports = __webpack_public_path__ + "static/2020-header-45cea9949ff8a13c28773b8b3b499d8d.jpg";